module.exports = __webpack_public_path__ + "static/media/1008436.3fb47a53.png";